export default __webpack_public_path__ + "media/images/promo-block/guest-list-b48557bb2c2eefcb18c1ab3ff422ce5c.gif";